import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';

const TST = ({ nightly }: { nightly: NightlyResponse }) => {
  const { t } = useTranslation();
  return (
    <StyledCard id="tst-label" title={t('summary.tst-label')}>
      <div>
        <Row gutter={[16, 16]}>
          <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
            {t('nightly.tst')}
          </Col>
          <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
            {nightly?.settings?.useTSTFull
              ? nightly?.variables?.formattedTSTFull
              : nightly?.variables?.formattedTST}
          </Col>
        </Row>
        {nightly?.settings?.showTRT && (
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
              {t('nightly.rem')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
              {nightly?.variables?.formattedTRT}
            </Col>
          </Row>
        )}
        {nightly?.settings?.showSE && (
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
              {t('nightly.se')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
              {nightly?.variables?.SE}%
            </Col>
          </Row>
        )}
      </div>
    </StyledCard>
  );
};

export default TST;
